import englishTranslation from "./en";
import polishTranslation from "./pl";
import spanishTranslation from "./esp";

const resources = {
    resources: {
        ...englishTranslation,
        ...polishTranslation,
        ...spanishTranslation,
    },
};

export default resources;
